var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 113,
    viewBox: "0 0 209 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.29 92.6307L127.01 94.5332C127.01 99.7653 135.214 103.927 139.852 103.927H159.115C163.872 103.927 167.677 99.6463 167.677 94.5332V92.6307C167.677 87.3987 163.872 83.2368 159.115 83.2368H139.852C135.095 83.2368 131.29 87.5176 131.29 92.6307Z",
    fill: "url(#paint0_linear_141_83)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.853 103.808C135.096 103.808 127.01 99.5272 127.01 94.4141L131.291 92.5115C131.291 87.3984 135.096 83.2366 139.615 83.1177H150.673V103.808H139.853Z",
    fill: "url(#paint1_linear_141_83)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.582 103.688C139.377 103.451 132.837 102.143 132.837 100.716C132.837 99.2887 139.496 98.3374 147.701 98.5752C155.905 98.8131 162.445 100.121 162.445 101.548C162.445 102.975 155.786 103.926 147.582 103.688Z",
    fill: "url(#paint2_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.18 101.192C166.488 99.7646 167.32 97.9809 167.677 95.9595H128.555V98.3377C129.388 99.4079 130.577 100.359 131.885 101.192H165.18Z",
    fill: "url(#paint3_linear_141_83)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.29 19.5005L127.01 17.598C127.01 12.3659 135.214 8.2041 139.852 8.2041L159.115 8.2041C163.872 8.2041 167.677 12.4848 167.677 17.598V19.5005C167.677 24.7325 163.872 28.8944 159.115 28.8944L139.852 28.8944C135.095 28.8944 131.29 24.6136 131.29 19.5005Z",
    fill: "url(#paint4_linear_141_83)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.853 8.2041C135.096 8.2041 127.01 12.4848 127.01 17.598L131.291 19.5005C131.291 24.6136 135.096 28.7755 139.615 28.8944H150.673V8.2041L139.853 8.2041Z",
    fill: "url(#paint5_linear_141_83)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.531 13.5555C140.326 13.7934 133.786 12.8421 133.667 11.4152C133.667 9.98825 140.207 8.68025 148.412 8.44243C156.617 8.20461 163.157 9.15588 163.276 10.5828C163.276 12.0097 156.736 13.3177 148.531 13.5555Z",
    fill: "url(#paint6_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5367 92.6307L17.256 94.5332C17.256 99.7653 25.3419 103.927 30.0982 103.927H49.3616C54.118 103.927 57.9231 99.6463 57.9231 94.5332V92.6307C57.9231 87.3987 54.118 83.2368 49.3616 83.2368H30.0982C25.3419 83.2368 21.5367 87.5176 21.5367 92.6307Z",
    fill: "url(#paint7_linear_141_83)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.0991 103.808C25.3428 103.808 17.2569 99.5272 17.2569 94.4141L21.5377 92.5115C21.5377 87.3984 25.3428 83.2366 29.8613 83.1177H40.9199V103.808H30.0991Z",
    fill: "url(#paint8_linear_141_83)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8281 103.688C29.6233 103.451 23.0833 102.143 23.0833 100.716C23.0833 99.2887 29.7422 98.3374 37.947 98.5752C46.1517 98.8131 52.6918 100.121 52.6918 101.548C52.6918 102.975 46.0328 103.926 37.8281 103.688Z",
    fill: "url(#paint9_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.307 101.192C56.615 99.7646 57.4473 97.9809 57.8041 95.9595H18.6828V98.3377C19.5152 99.4079 20.7043 100.359 22.0123 101.192H55.307Z",
    fill: "url(#paint10_linear_141_83)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.537 19.5005L17.2562 17.598C17.2562 12.3659 25.3421 8.2041 30.0985 8.2041L49.3618 8.2041C54.1182 8.2041 57.9233 12.4848 57.9233 17.598V19.5005C57.9233 24.7325 54.1182 28.8944 49.3618 28.8944L30.0985 28.8944C25.3421 28.8944 21.537 24.6136 21.537 19.5005Z",
    fill: "url(#paint11_linear_141_83)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.0991 8.2041C25.3428 8.2041 17.2569 12.4848 17.2569 17.598L21.5377 19.5005C21.5377 24.6136 25.3428 28.7755 29.8613 28.8944H40.9199V8.2041L30.0991 8.2041Z",
    fill: "url(#paint12_linear_141_83)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6612 13.5555C30.4565 13.7934 23.9164 12.8421 23.7975 11.4152C23.7975 9.98825 30.3375 8.68025 38.5423 8.44243C46.7471 8.20461 53.2871 9.15588 53.406 10.5828C53.406 12.0097 46.866 13.3177 38.6612 13.5555Z",
    fill: "url(#paint13_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195.263 92.9872C201.208 86.8039 203.705 77.0533 203.705 77.0533C203.705 77.0533 208.343 70.3944 208.343 56.0063C208.343 41.6183 203.705 34.9593 203.705 34.9593C203.705 34.9593 201.089 25.2087 195.263 19.0254C187.772 11.0585 171.957 9.86938 166.843 9.86938L61.2517 9.86938C55.544 9.86938 29.7407 12.0098 25.2221 12.3665C17.7308 12.961 11.6664 15.2203 6.19655 23.6629C0.36998 32.8189 0.0132446 56.0063 0.0132446 56.0063C0.0132446 56.0063 -0.581299 78.1235 6.19655 88.3497C11.7853 96.6734 17.7308 99.0516 25.2221 99.6461C29.7407 100.003 55.544 102.143 61.2517 102.143L166.962 102.143C171.957 102.143 187.772 100.954 195.382 92.9872H195.263Z",
    fill: "url(#paint14_linear_141_83)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M203.826 35.0775L195.264 28.8942C195.264 28.8942 192.054 23.6621 190.151 21.165C188.367 18.9058 185.038 15.1006 185.038 15.1006C185.038 15.1006 191.816 14.8628 196.453 20.3327C201.804 26.6349 203.707 34.9586 203.707 34.9586L203.826 35.0775Z",
    fill: "url(#paint15_linear_141_83)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.039 15.1006C185.039 15.1006 188.963 19.5002 190.152 21.165C191.579 22.9486 195.265 28.8941 195.265 28.8941L202.162 33.8883C200.735 30.6777 197.168 23.6621 194.195 20.5704C191.223 17.3599 189.082 16.1708 185.158 15.2195L185.039 15.1006Z",
    fill: "url(#paint16_linear_141_83)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.141 28.5378L201.924 32.224C201.924 32.224 200.378 30.916 199.427 28.8945C198.476 26.873 197.881 25.0894 198.238 24.8516C198.595 24.6138 199.784 26.1596 200.735 28.181C201.449 29.4891 201.924 30.7971 202.043 31.6294L200.141 28.5378Z",
    fill: "url(#paint17_linear_141_83)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M203.826 77.0535L195.264 83.2368C195.264 83.2368 192.054 88.4688 190.151 90.9659C188.367 93.2252 185.038 97.0303 185.038 97.0303C185.038 97.0303 191.816 97.2681 196.453 91.7983C201.804 85.496 203.707 77.1724 203.707 77.1724L203.826 77.0535Z",
    fill: "url(#paint18_linear_141_83)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185.039 96.911C185.039 96.911 188.963 92.5114 190.152 90.8466C191.579 89.063 195.265 83.1175 195.265 83.1175L202.162 78.1233C200.735 81.3339 197.168 88.3495 194.195 91.4412C191.223 94.6517 189.082 95.8408 185.158 96.7921L185.039 96.911Z",
    fill: "url(#paint19_linear_141_83)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.141 83.5932L201.924 79.907C201.924 79.907 200.378 81.215 199.427 83.2365C198.476 85.2579 197.881 87.0416 198.238 87.2794C198.595 87.5172 199.784 85.9714 200.735 83.9499C201.449 82.6419 201.924 81.3339 202.043 80.5015L200.141 83.5932Z",
    fill: "url(#paint20_linear_141_83)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.402 26.6356C195.024 22.5927 193.597 19.0254 194.192 18.6687C194.786 18.3119 197.164 21.4036 199.424 25.4465C201.802 29.4894 203.229 33.0567 202.634 33.4134C202.04 33.7702 199.661 30.6785 197.402 26.6356Z",
    fill: "url(#paint21_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3082 11.7722C29.622 12.01 26.6493 12.2479 25.3413 12.3668C17.85 12.9613 11.7856 15.2206 6.31574 23.6632C0.489166 32.8192 0.132431 56.0066 0.132431 56.0066C0.132431 56.0066 -0.462112 78.1238 6.31574 88.35C11.9045 96.6737 17.85 99.0519 25.3413 99.6464C26.6493 99.6464 29.622 100.003 33.3082 100.241L33.3082 11.7722Z",
    fill: "url(#paint22_linear_141_83)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M134.62 81.9278C136.88 69.5612 136.88 42.5688 134.62 30.2022C133.669 25.208 129.269 21.5218 124.037 21.5218L34.2607 21.2839C34.2607 21.2839 33.4283 21.2839 33.0715 21.6407C30.5744 23.1865 20.7049 30.9156 20.7049 56.1245C20.7049 81.3333 30.8123 89.1813 33.1905 90.6082C33.5472 90.8461 33.9039 90.8461 34.2607 90.8461L124.156 90.6082C129.269 90.6082 133.788 86.922 134.739 81.9278H134.62Z",
    fill: "url(#paint23_linear_141_83)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.458 57.6706C130.458 57.6706 112.74 47.5633 77.4242 47.5633C42.1081 47.5633 21.7745 59.9299 21.7745 59.9299C21.7745 59.9299 17.6127 38.0505 28.9091 24.0192C33.6655 18.0737 55.9016 18.7872 78.0188 18.9061C102.395 19.1439 126.653 19.2628 126.891 21.9977C127.366 27.3487 132.479 43.7582 130.577 57.5517L130.458 57.6706Z",
    fill: "url(#paint24_linear_141_83)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M144.252 13.199L141.517 8.56149L140.684 8.91822C138.425 5.35093 133.431 0 133.431 0C133.431 0 132.598 0.475638 132.48 1.42692C132.361 2.37819 135.452 9.98841 135.452 9.98841L137.236 10.3451C137.236 10.3451 138.068 11.0586 138.187 11.6531C138.306 12.6044 137.949 13.9124 137.949 13.9124L144.252 13.0801V13.199Z",
    fill: "url(#paint25_linear_141_83)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.874 11.0586C141.874 11.0586 141.636 11.2964 141.636 11.0586C141.042 10.464 139.734 9.03713 138.901 8.56149C137.712 7.84803 136.404 7.25349 136.404 7.25349L133.432 0C133.432 0 135.929 0.713458 138.069 2.61601C141.28 5.58875 141.755 9.63168 141.755 10.9397L141.874 11.0586Z",
    fill: "url(#paint26_linear_141_83)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.572 9.98852C135.572 9.98852 132.718 4.99432 132.362 1.66485C132.362 1.30812 132.362 0.594664 132.837 0.237935C133.075 0.000115506 133.313 0.000115506 133.432 0.237935C135.929 2.14049 136.405 7.49142 136.405 7.49142L135.453 10.1074L135.572 9.98852Z",
    fill: "url(#paint27_linear_141_83)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.286 7.37224L135.572 9.63152C134.978 8.44242 132.956 4.51841 132.6 1.66458C132.6 1.66458 132.6 1.42676 132.6 1.18894C132.6 0.832208 132.6 0.475479 132.956 0.35657C133.313 0.11875 133.67 0.23766 133.789 0.35657C135.929 1.90239 136.405 6.8966 136.524 7.37224H136.286ZM136.405 7.37224C136.405 7.37224 135.929 1.78348 133.67 0.11875C133.432 -0.00015931 133.075 -0.119069 132.6 0.11875C132.243 0.35657 132.243 0.832208 132.243 1.18894C132.243 1.42676 132.243 1.54567 132.243 1.66458C132.6 4.99404 135.453 9.98825 135.453 9.98825L136.405 7.37224Z",
    fill: "#1E1E1E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M144.252 98.9332L141.517 103.571L140.685 103.214C138.425 106.781 133.431 112.132 133.431 112.132C133.431 112.132 132.599 111.657 132.48 110.705C132.361 109.754 135.453 102.144 135.453 102.144L137.236 101.787C137.236 101.787 138.069 101.074 138.187 100.479C138.306 99.5277 137.95 98.2197 137.95 98.2197L144.252 99.0521V98.9332Z",
    fill: "url(#paint28_linear_141_83)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M141.874 101.073C141.874 101.073 141.636 100.835 141.636 101.073C141.042 101.668 139.734 103.094 138.901 103.57C137.712 104.284 136.404 104.878 136.404 104.878L133.432 112.25C133.432 112.25 135.929 111.537 138.069 109.634C141.28 106.662 141.755 102.619 141.755 101.311L141.874 101.073Z",
    fill: "url(#paint29_linear_141_83)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M135.572 102.143C135.572 102.143 132.718 107.137 132.362 110.467C132.362 110.823 132.362 111.537 132.837 111.893C133.075 112.131 133.313 112.131 133.432 111.893C135.929 109.991 136.405 104.64 136.405 104.64L135.453 102.024L135.572 102.143Z",
    fill: "url(#paint30_linear_141_83)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.286 104.759C136.286 104.759 135.691 110.348 133.551 111.775C133.551 111.775 133.075 112.013 132.718 111.775C132.481 111.537 132.362 111.299 132.362 110.943C132.362 110.824 132.362 110.586 132.362 110.467C132.718 107.732 134.74 103.689 135.334 102.5L136.048 104.759H136.286ZM136.405 104.759L135.453 102.143C135.453 102.143 132.6 107.138 132.243 110.467C132.243 110.467 132.243 110.705 132.243 110.943C132.243 111.299 132.243 111.656 132.6 112.013C132.956 112.37 133.432 112.251 133.67 112.013C136.048 110.348 136.405 104.759 136.405 104.759Z",
    fill: "#1E1E1E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M148.174 13.1987C148.174 13.1987 127.602 19.2631 119.992 19.9766C112.382 20.809 85.6274 20.4522 85.6274 20.4522L89.5514 13.0798L148.055 13.0798L148.174 13.1987Z",
    fill: "url(#paint31_linear_141_83)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5355 13.0798L80.7519 20.3333L40.7982 19.7388L65.0558 13.1987L82.5355 13.0798Z",
    fill: "url(#paint32_linear_141_83)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6711 13.0798H82.5366L80.7529 20.3333L85.7471 20.5711L89.6711 13.0798Z",
    fill: "#272727"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M144.014 13.1983L141.517 8.2041L137.593 10.1067C137.593 10.1067 138.663 11.2958 138.544 11.8903V12.4848L138.187 13.3172H144.014V13.1983Z",
    fill: "#0E0E0E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M203.824 77.0535C206.916 73.6051 208.462 65.2815 208.462 56.0065C208.462 46.7316 206.916 38.4079 203.824 34.9595C193.241 23.4253 154.953 14.7449 154.953 14.7449C154.953 14.7449 166.368 25.5656 166.368 56.0065C166.368 86.4474 154.953 97.2682 154.953 97.2682C154.953 97.2682 193.123 88.5877 203.824 77.0535Z",
    fill: "url(#paint33_linear_141_83)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M148.174 98.8141C148.174 98.8141 127.602 92.7497 119.992 92.0362C112.382 91.2039 85.6274 91.5606 85.6274 91.5606L89.5514 98.933H148.055L148.174 98.8141Z",
    fill: "url(#paint34_linear_141_83)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5355 99.0514L80.7519 91.679L40.7982 92.2735L65.0558 98.9324L82.5355 99.0514Z",
    fill: "url(#paint35_linear_141_83)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6711 99.0514H82.5366L80.7529 91.679L85.7471 91.5601L89.6711 99.0514Z",
    fill: "#272727"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M144.014 98.8132L141.517 103.807L137.593 101.905C137.593 101.905 138.663 100.716 138.544 100.121V99.5267L138.187 98.6943H144.014V98.8132Z",
    fill: "#0E0E0E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2282 56.0059C20.2282 27.4676 33.3082 21.2843 33.3082 21.2843C33.3082 21.2843 19.2769 20.0952 12.3801 26.8731C7.38593 31.8673 7.02919 56.0059 7.02919 56.0059C7.02919 56.0059 5.72119 78.4798 12.3801 85.1388C19.2769 92.0355 33.3082 90.7275 33.3082 90.7275C33.3082 90.7275 20.2282 84.4253 20.2282 56.0059Z",
    fill: "url(#paint36_linear_141_83)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8934 65.2814C21.8934 65.2814 21.5367 58.3847 21.5367 56.1254C21.5367 53.8661 21.8934 47.5639 21.8934 46.9693C21.8934 46.3748 20.8232 46.0181 20.8232 46.0181C20.1098 49.2286 20.2287 56.1254 20.2287 56.1254C20.2287 56.1254 20.2287 63.0221 20.8232 66.2327C20.8232 66.2327 21.8934 65.876 21.8934 65.2814Z",
    fill: "#BD0000"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M163.632 56.0057C163.632 56.0057 163.988 25.0892 149.838 15.4575L125.818 21.5219C125.818 21.5219 128.197 35.4343 128.197 56.0057C128.197 76.5771 125.818 90.4895 125.818 90.4895L149.838 96.5539C163.988 86.8033 163.632 56.0057 163.632 56.0057Z",
    fill: "url(#paint37_linear_141_83)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.7578 11.4156C72.1923 11.4156 51.502 11.1778 51.502 10.94C51.502 10.7022 72.1923 10.4644 97.7578 10.4644C123.323 10.4644 144.014 10.7022 144.014 10.94C144.014 11.1778 123.323 11.4156 97.7578 11.4156Z",
    fill: "url(#paint38_radial_141_83)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203.824 35.0786C193.241 23.5444 154.953 14.864 154.953 14.864C154.953 14.864 161.136 20.8095 164.465 36.1488C171.838 37.3379 186.701 38.1703 194.549 39.4783C206.916 41.6187 207.63 52.2016 208.462 52.6773C208.105 44.8292 206.559 38.0514 203.824 35.0786Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.824 77.0535C193.241 88.5877 154.953 97.2681 154.953 97.2681C154.953 97.2681 161.136 91.3226 164.465 75.9833C173.265 75.3887 187.772 73.724 197.284 71.4647C209.056 68.6109 207.63 59.9305 208.462 59.4548C208.105 67.3029 206.559 74.0807 203.824 77.0535Z",
    fill: "url(#paint39_linear_141_83)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M202.159 35.078C203.586 34.4834 198.235 20.571 187.176 15.2201C174.572 9.1557 143.299 13.0797 142.942 14.031C142.585 15.1012 200.256 35.7915 202.159 35.078Z",
    fill: "#808080"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M201.802 34.7209C203.11 34.1263 197.878 20.3328 187.176 15.2197C174.929 9.39311 144.488 12.9604 144.131 14.0306C143.774 15.1008 199.9 35.5532 201.802 34.7209Z",
    fill: "#868686"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M201.445 34.4832C202.753 33.8887 197.521 20.2141 187.057 15.3388C175.166 9.75003 145.558 13.0795 145.201 14.1497C144.844 15.2199 199.661 35.3156 201.445 34.4832Z",
    fill: "#8C8C8C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M201.088 34.1272C202.396 33.5327 197.164 20.0959 187.056 15.3395C175.641 9.9886 146.746 13.0802 146.389 14.1504C145.914 15.2206 199.423 34.9596 201.088 34.2462V34.1272Z",
    fill: "#929292"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M200.733 33.7697C201.922 33.1752 196.809 19.8573 187.058 15.3387C175.999 10.1067 147.937 13.0794 147.461 14.0307C146.986 15.1009 198.949 34.4832 200.733 33.7697Z",
    fill: "#989898"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M200.256 33.5327C201.445 32.9382 196.332 19.8581 186.938 15.4584C176.236 10.4642 149.006 13.0802 148.53 14.1504C148.055 15.2206 198.591 34.3651 200.256 33.5327Z",
    fill: "#9E9E9E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M199.899 33.1753C201.088 32.5807 195.975 19.6196 186.819 15.4577C176.593 10.7013 150.076 13.0795 149.6 14.1497C149.124 15.2199 198.353 34.0076 199.899 33.1753Z",
    fill: "#A4A4A4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M199.543 32.938C200.613 32.3435 195.619 19.5012 186.819 15.5772C176.95 11.0586 151.265 13.199 150.79 14.2692C150.195 15.3394 197.997 33.7704 199.543 33.0569V32.938Z",
    fill: "#AAAAAA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M199.185 32.5811C200.256 31.9866 195.261 19.3822 186.819 15.5771C177.425 11.2963 152.454 13.1989 151.859 14.269C151.265 15.3392 197.64 33.5324 199.185 32.7V32.5811Z",
    fill: "#B0B0B0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M198.831 32.3425C199.782 31.8668 194.907 19.2624 186.821 15.5762C177.784 11.5333 153.645 13.0791 153.05 14.1493C152.456 15.2195 197.404 33.0559 198.831 32.2236V32.3425Z",
    fill: "#B6B6B6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M198.473 31.9866C199.425 31.511 194.549 19.0255 186.701 15.5771C178.021 11.772 154.715 13.08 154.12 14.1502C153.526 15.2204 197.046 32.819 198.473 31.9866Z",
    fill: "#BCBCBC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M198.116 31.7491C199.067 31.2735 194.192 19.0258 186.701 15.6963C178.496 12.129 155.903 13.1992 155.309 14.2694C154.714 15.3396 196.808 32.4626 198.116 31.7491Z",
    fill: "#C3C3C3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M197.758 31.392C198.591 30.9163 193.834 18.7875 186.7 15.6959C178.852 12.2475 157.091 13.1988 156.497 14.269C155.783 15.3392 196.45 32.2243 197.877 31.392H197.758Z",
    fill: "#C9C9C9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M197.402 31.0347C198.235 30.5591 193.478 18.5492 186.701 15.6954C179.209 12.4848 158.281 13.1983 157.568 14.1496C156.854 15.2198 196.094 31.7482 197.402 30.9158V31.0347Z",
    fill: "#CFCFCF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M196.926 30.798C197.759 30.3223 193.002 18.5503 186.462 15.8154C179.447 12.8426 159.232 13.1993 158.518 14.2695C157.805 15.3397 195.737 31.6303 196.926 30.798Z",
    fill: "#D5D5D5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M196.571 30.441C197.284 29.9654 192.647 18.3123 186.464 15.8152C179.805 13.0802 160.422 13.1991 159.709 14.2693C158.995 15.3395 195.382 31.2734 196.571 30.441Z",
    fill: "#DBDBDB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M196.214 30.2024C196.927 29.7268 192.29 18.3115 186.463 15.9333C180.28 13.4362 161.611 13.3173 160.898 14.3875C160.184 15.4576 195.144 31.0348 196.214 30.2024Z",
    fill: "#E1E1E1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M195.857 29.8461C196.451 29.3704 191.933 18.074 186.463 15.9337C180.636 13.6744 162.8 13.3176 162.087 14.3878C161.254 15.458 194.906 30.6784 195.976 29.965L195.857 29.8461Z",
    fill: "#E7E7E7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M195.499 29.6088C196.094 29.1331 191.575 17.9556 186.343 16.0531C180.873 14.0316 163.869 13.3181 163.037 14.3883C162.204 15.4585 194.429 30.4411 195.38 29.6088H195.499Z",
    fill: "#EDEDED"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M195.143 29.2517C195.143 29.2517 191.219 17.8364 186.343 16.0527C181.349 14.1502 165.058 13.3178 164.226 14.388C163.394 15.4582 194.191 30.084 195.143 29.2517Z",
    fill: "#F3F3F3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M194.786 29.0139C194.786 29.0139 190.862 17.7174 186.343 16.1716C181.705 14.5069 166.247 13.4367 165.415 14.5069C164.582 15.5771 193.834 29.8462 194.786 29.0139Z",
    fill: "#F9F9F9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M194.432 28.6577C194.432 28.6577 190.507 17.4802 186.346 16.1722C182.065 14.7453 167.439 13.4373 166.607 14.5075C165.655 15.5777 193.599 29.609 194.55 28.7766L194.432 28.6577Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2398 78.4802C8.81293 79.0747 15.2341 94.0573 20.8228 97.0301C26.4116 100.003 64.7004 99.1704 65.0572 98.1002C65.4139 97.0301 12.1424 77.6478 10.2398 78.4802Z",
    fill: "#808080"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4765 78.8376C9.16852 79.4322 15.4707 94.177 20.9406 97.1497C26.4104 100.122 63.6291 99.2901 63.9858 98.2199C64.3426 97.1497 12.3791 78.0053 10.4765 78.8376Z",
    fill: "#868686"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5971 79.0747C9.2891 79.6693 15.5913 94.1763 20.9422 97.149C26.4121 100.003 62.4417 99.2894 62.7984 98.2192C63.1552 97.149 12.3807 78.3613 10.5971 79.0747Z",
    fill: "#8C8C8C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7162 79.313C9.40822 79.9076 15.5915 94.2957 20.9424 97.0306C26.2934 99.7655 61.2528 99.1709 61.6095 98.1008C62.0852 97.0306 12.381 78.4807 10.5973 79.1941L10.7162 79.313Z",
    fill: "#929292"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9531 79.55C9.76397 80.1446 15.8284 94.2948 21.0604 97.0298C26.4113 99.7647 60.1816 99.289 60.6573 98.2189C61.1329 97.1487 12.7367 78.8366 10.9531 79.669V79.55Z",
    fill: "#989898"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0708 79.7884C9.88169 80.3829 15.8272 94.2953 21.0592 96.9114C26.2912 99.5274 58.9914 99.1706 59.467 98.1005C59.9426 97.0303 12.7355 78.956 11.0708 79.7884Z",
    fill: "#9E9E9E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1913 80.0253C10.0022 80.6199 15.9477 94.2945 21.0608 96.9105C26.1739 99.4076 57.8039 99.1698 58.2795 98.0996C58.7552 97.0294 12.7372 79.1929 11.1913 80.0253Z",
    fill: "#A4A4A4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M11.428 80.2635C10.3578 80.858 16.0654 94.4137 21.1785 96.7919C26.2916 99.289 56.7325 99.0512 57.2081 97.981C57.6838 96.9108 12.9738 79.4311 11.309 80.1445L11.428 80.2635Z",
    fill: "#AAAAAA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5464 80.502C10.4763 81.0966 16.1839 94.4144 21.1781 96.7926C26.1723 99.1708 55.543 99.1708 56.1375 98.1006C56.7321 97.0304 13.0923 79.7885 11.5464 80.502Z",
    fill: "#B0B0B0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 80.7393C10.7157 81.2149 16.1856 94.4139 21.1798 96.6732C26.174 98.9325 54.3556 99.0514 54.9501 97.9812C55.5447 96.911 13.0939 79.9069 11.667 80.7393Z",
    fill: "#B6B6B6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9035 80.9777C10.9522 81.4534 16.4221 94.4145 21.2974 96.6738C26.1727 98.9331 53.2841 99.052 53.8786 97.9818C54.4732 96.9116 13.3304 80.1454 11.9035 80.9777Z",
    fill: "#BCBCBC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M12.024 81.215C11.0727 81.6906 16.5425 94.4139 21.2989 96.6732C26.1742 98.8136 52.0965 99.0514 52.6911 97.9812C53.2856 96.911 13.332 80.3826 11.9051 81.215H12.024Z",
    fill: "#C3C3C3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1415 81.4534C11.3091 81.9291 16.5411 94.5335 21.2975 96.555C26.0539 98.5764 50.906 99.0521 51.5006 97.9819C52.214 96.9117 13.3306 80.6211 12.0226 81.4534H12.1415Z",
    fill: "#C9C9C9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M12.381 81.691C11.5486 82.1666 16.7807 94.5332 21.4181 96.5547C26.1745 98.5761 49.8375 99.0518 50.551 97.9816C51.2645 96.9114 13.689 80.9775 12.381 81.691Z",
    fill: "#CFCFCF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4985 81.9292C11.6661 82.4048 16.7792 94.5336 21.5356 96.4361C26.1731 98.3387 48.7659 98.9332 49.4794 97.8631C50.1928 96.7929 13.8065 81.0968 12.6174 81.9292H12.4985Z",
    fill: "#D5D5D5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6188 82.1662C11.9053 82.6419 16.8995 94.5328 21.537 96.4354C26.1745 98.3379 47.5782 98.9325 48.2917 97.8623C49.0051 96.7921 13.8079 81.3338 12.6188 82.1662Z",
    fill: "#DBDBDB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8551 82.5236C12.1416 82.9993 17.0169 94.6524 21.6544 96.4361C26.173 98.2197 46.5065 99.0521 47.22 97.9819C47.9334 96.9117 14.0442 81.6913 12.8551 82.5236Z",
    fill: "#E1E1E1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9754 82.761C12.3809 83.2366 17.1373 94.7708 21.6558 96.4356C26.1744 98.1003 45.3189 99.0516 46.0323 97.9814C46.7458 96.9112 14.0456 81.9286 12.9754 82.761Z",
    fill: "#E7E7E7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0945 82.9995C12.4999 83.4752 17.1374 94.7716 21.656 96.4363C26.0556 98.101 44.1299 99.0523 44.9623 97.9821C45.7946 96.9119 14.1647 82.1671 13.2134 82.9995H13.0945Z",
    fill: "#EDEDED"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2115 83.2369C13.2115 83.2369 17.2544 94.7711 21.6541 96.317C26.0537 97.8628 42.9389 98.933 43.7713 97.8628C44.6036 96.7926 14.2817 82.4045 13.2115 83.2369Z",
    fill: "#F3F3F3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4505 83.4749C13.4505 83.4749 17.4934 94.7713 21.7741 96.3171C26.0549 97.8629 41.8699 99.052 42.7022 97.9818C43.5346 96.9116 14.4017 82.7614 13.4505 83.5938V83.4749Z",
    fill: "#F9F9F9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5704 83.7126C13.5704 83.7126 17.4944 94.7712 21.7751 96.1982C26.0559 97.6251 40.6818 98.9331 41.5141 97.8629C42.3465 96.7927 14.4027 82.8803 13.5704 83.7126Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M200.256 77.0526C201.683 77.6471 194.667 93.6999 189.079 96.7916C183.49 99.8832 146.271 99.6454 145.914 98.5752C145.558 97.505 198.354 76.2202 200.256 77.0526Z",
    fill: "#808080"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M200.018 77.4087C201.326 78.0032 194.548 93.8182 189.078 96.791C183.609 99.7637 147.341 99.6448 146.984 98.5746C146.628 97.5044 198.234 76.5763 200.018 77.4087Z",
    fill: "#868686"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M199.899 77.6469C201.207 78.2414 194.429 93.8186 189.078 96.6724C183.608 99.5263 148.53 99.5263 148.054 98.4561C147.698 97.3859 197.996 76.8145 199.899 77.6469Z",
    fill: "#8C8C8C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M199.661 78.0036C200.969 78.5981 194.31 93.9375 188.96 96.6724C183.609 99.5262 149.482 99.5262 149.125 98.456C148.649 97.3858 197.878 77.1712 199.661 77.8847V78.0036Z",
    fill: "#929292"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M199.542 78.2419C200.731 78.8365 194.31 93.8191 188.959 96.554C183.727 99.2889 150.67 99.4078 150.195 98.3377C149.719 97.2675 197.758 77.4096 199.542 78.123V78.2419Z",
    fill: "#989898"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M199.304 78.5982C200.493 79.1928 194.072 93.9375 188.84 96.6725C183.608 99.2885 151.74 99.5263 151.264 98.4561C150.789 97.3859 197.639 77.8847 199.304 78.5982Z",
    fill: "#9E9E9E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M199.066 78.8363C200.255 79.4309 193.953 93.9379 188.84 96.5539C183.727 99.1699 152.81 99.4077 152.335 98.3375C151.859 97.2673 197.52 78.1229 199.066 78.8363Z",
    fill: "#A4A4A4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M198.949 79.1924C200.019 79.787 193.955 94.0561 188.842 96.5532C183.729 99.0503 154.001 99.4071 153.407 98.3369C152.812 97.2667 197.403 78.479 198.949 79.1924Z",
    fill: "#AAAAAA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M198.711 79.4308C199.781 80.0254 193.717 94.0567 188.723 96.4349C183.728 98.8131 154.952 99.2887 154.477 98.2186C153.882 97.1484 197.165 78.7174 198.711 79.4308Z",
    fill: "#B0B0B0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M198.59 79.7867C199.541 80.2624 193.715 94.0559 188.721 96.4341C183.726 98.8123 156.139 99.2879 155.545 98.2177C154.95 97.1475 197.044 78.9544 198.59 79.7867Z",
    fill: "#B6B6B6"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M198.353 80.0253C199.304 80.5009 193.597 94.0566 188.602 96.3159C183.727 98.5752 157.21 99.1698 156.616 98.0996C156.021 97.0294 196.926 79.1929 198.353 80.0253Z",
    fill: "#BCBCBC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M198.234 80.3816C199.186 80.8572 193.478 94.1751 188.721 96.3155C183.846 98.4558 158.4 99.1693 157.805 98.0991C157.21 97.0289 196.926 79.5492 198.353 80.3816H198.234Z",
    fill: "#C3C3C3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M197.996 80.6202C198.828 81.0958 193.358 94.1759 188.602 96.1974C183.845 98.3377 159.469 99.0512 158.756 97.981C158.042 96.9108 196.688 79.7878 197.996 80.6202Z",
    fill: "#C9C9C9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M197.878 80.9765C198.71 81.4522 193.359 94.1755 188.603 96.1969C183.847 98.2184 160.54 99.0508 159.946 97.9806C159.232 96.9104 196.689 80.1441 197.878 80.9765Z",
    fill: "#CFCFCF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M197.64 81.2151C198.472 81.6907 193.121 94.1762 188.484 96.1977C183.846 98.2192 161.61 99.0515 160.897 97.9813C160.183 96.9112 196.332 80.5016 197.64 81.334V81.2151Z",
    fill: "#D5D5D5"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M197.404 81.5708C198.117 82.0464 193.004 94.2941 188.367 96.1967C183.729 98.0992 162.682 99.0505 161.85 97.9803C161.136 96.9101 196.096 80.8573 197.285 81.6897L197.404 81.5708Z",
    fill: "#DBDBDB"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M197.282 81.8088C197.996 82.2845 193.001 94.2943 188.483 96.078C183.964 97.8616 163.868 98.9318 163.155 97.8616C162.442 96.7914 196.212 81.0954 197.401 81.9277L197.282 81.8088Z",
    fill: "#E1E1E1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M197.047 82.1658C197.641 82.6414 192.766 94.2946 188.366 96.0782C183.848 97.7429 164.941 98.8131 164.109 97.8618C163.276 96.7917 195.977 81.4523 197.047 82.2847V82.1658Z",
    fill: "#E7E7E7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M196.927 82.4038C197.521 82.8794 192.765 94.2947 188.365 95.9595C183.965 97.6242 166.01 98.6944 165.297 97.6242C164.583 96.554 195.975 81.5714 196.927 82.4038Z",
    fill: "#EDEDED"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M196.69 82.7599C196.69 82.7599 192.647 94.413 188.247 95.9589C183.847 97.5047 167.081 98.6938 166.249 97.6236C165.416 96.5534 195.738 81.9275 196.69 82.641V82.7599Z",
    fill: "#F3F3F3"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M196.571 82.9986C196.571 82.9986 192.528 94.414 188.247 95.8409C183.966 97.2678 168.27 98.5758 167.319 97.5056C166.487 96.4354 195.619 82.0474 196.452 82.8797L196.571 82.9986Z",
    fill: "#F9F9F9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M196.333 83.3552C196.333 83.3552 192.409 94.5327 188.247 95.8407C183.966 97.2676 169.34 98.5756 168.508 97.5054C167.676 96.4352 195.5 82.4039 196.452 83.2363L196.333 83.3552Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M161.731 15.4588C149.959 14.9832 140.327 13.6752 140.446 12.4861C140.446 11.297 150.078 10.5835 161.85 11.0591C173.622 11.5348 183.253 12.8428 183.134 14.0319C183.134 15.221 173.503 15.9344 161.731 15.4588Z",
    fill: "url(#paint40_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.632 56.0057C163.632 56.0057 163.988 25.0892 149.838 15.4575L125.818 21.5219C125.818 21.5219 127.364 30.559 127.959 44.9471C140.207 46.1362 163.513 57.6704 163.513 57.6704C163.513 56.6002 163.513 56.0057 163.513 56.0057H163.632Z",
    fill: "url(#paint41_linear_141_83)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.542 18.5497C129.148 21.0468 121.538 22.5927 121.419 22.117C121.3 21.6414 128.791 19.1443 138.066 16.6472C147.46 14.1501 155.07 12.6043 155.189 13.0799C155.308 13.5555 147.817 16.0526 138.542 18.5497Z",
    fill: "url(#paint42_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.032 13.1987C82.2985 13.1987 62.3217 12.7231 62.3217 12.2474C62.3217 11.7718 82.2985 11.2961 107.032 11.2961C131.765 11.2961 151.742 11.7718 151.742 12.2474C151.742 12.7231 131.765 13.1987 107.032 13.1987Z",
    fill: "url(#paint43_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.032 102.262C82.2985 102.262 62.3217 101.786 62.3217 101.31C62.3217 100.835 82.2985 100.359 107.032 100.359C131.765 100.359 151.742 100.835 151.742 101.31C151.742 101.786 131.765 102.262 107.032 102.262Z",
    fill: "url(#paint44_radial_141_83)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3217 100.122C62.3217 100.647 82.339 101.073 107.032 101.073C131.724 101.073 151.742 100.647 151.742 100.122C151.742 99.5963 131.724 99.1704 107.032 99.1704C82.339 99.1704 62.3217 99.5963 62.3217 100.122Z",
    fill: "url(#paint45_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.711 95.6039C128.436 92.9879 120.944 90.3719 121.182 89.8962C121.42 89.4206 129.03 91.0853 138.305 93.8203C147.58 96.5552 155.072 99.0523 154.834 99.5279C154.715 100.004 146.986 98.3388 137.711 95.6039Z",
    fill: "url(#paint46_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_141_83",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 15,
    width: 40,
    height: 82
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M164.942 56.0057C164.942 56.0057 164.466 24.9703 149.84 15.4575L125.821 21.403C125.821 21.403 128.318 35.7911 128.318 56.0057C128.318 76.2203 125.821 90.6084 125.821 90.6084L149.84 96.5539C164.466 87.0411 164.942 56.0057 164.942 56.0057Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_141_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.188 100.002C119.995 95.7216 105.844 89.4194 106.439 86.0899C107.033 82.7605 122.373 83.4739 140.447 87.7547C158.64 92.0354 172.79 98.3376 172.196 101.667C171.601 104.997 156.262 104.283 138.188 100.002Z",
    fill: "url(#paint47_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.499 51.2486C155.667 14.1488 161.731 -16.0542 170.055 -16.292C178.379 -16.5299 185.751 13.3164 186.583 50.4162C187.416 87.516 181.351 117.719 173.028 117.957C164.704 118.195 157.332 88.3484 156.499 51.2486Z",
    fill: "url(#paint48_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.144 52.3186C118.329 55.5292 103.228 44.4706 100.493 27.4665C97.7578 10.4624 108.222 -5.8282 124.037 -9.03876C139.852 -12.2493 154.953 -1.19072 157.688 15.8134C160.423 32.8174 149.959 49.108 134.144 52.3186Z",
    fill: "url(#paint49_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M154.952 14.864L149.72 15.4586C149.72 15.4586 163.157 23.9011 163.157 57.0769C163.157 84.5451 149.72 96.6738 149.72 96.6738L154.952 97.2684C154.952 97.2684 166.367 84.7829 166.367 57.7904C166.367 24.8524 154.952 14.864 154.952 14.864Z",
    fill: "#010101"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M154.953 14.864C154.953 14.864 189.912 22.712 202.041 33.1761C204.895 35.6732 205.608 37.8136 205.608 37.8136C205.608 37.8136 204.3 35.0786 200.614 32.3437C188.604 22.831 155.309 15.3397 155.309 15.3397L154.953 14.9829V14.864Z",
    fill: "url(#paint50_linear_141_83)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M154.953 97.2682C154.953 97.2682 189.912 89.4201 202.041 78.9561C204.895 76.459 205.608 74.3186 205.608 74.3186C205.608 74.3186 204.3 77.0535 200.614 79.7884C188.604 89.3012 155.309 96.7925 155.309 96.7925L154.953 97.1492V97.2682Z",
    fill: "url(#paint51_linear_141_83)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.091 32.5806C168.983 29.1322 161.373 24.6136 162.086 22.3544C162.8 20.0951 171.718 21.0464 181.825 24.4947C191.933 27.9431 199.543 32.4617 198.83 34.721C198.116 36.9802 189.198 36.029 179.091 32.5806Z",
    fill: "url(#paint52_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6643 24.3767C22.9624 25.328 14.1631 24.3767 14.0442 22.2363C13.8064 20.096 22.2489 17.4799 32.9508 16.4098C43.6527 15.4585 52.452 16.4098 52.5709 18.5501C52.8087 20.6905 44.3661 23.3065 33.6643 24.3767Z",
    fill: "url(#paint53_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8054 95.603C25.1036 94.6517 16.661 92.1546 16.7799 90.0142C17.0177 87.8739 25.817 86.8037 36.4 87.636C47.1018 88.5873 55.5444 91.0844 55.4255 93.2248C55.3066 95.3652 46.3884 96.4354 35.8054 95.603Z",
    fill: "url(#paint54_radial_141_83)",
    style: {
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91028 58.0276L20.2282 56.1251C20.2282 27.5868 33.3082 21.4035 33.3082 21.4035C33.3082 21.4035 19.2769 20.2144 12.3801 26.9922C7.38593 31.9864 7.02919 56.1251 7.02919 56.1251C7.02919 56.1251 7.02919 56.8385 7.02919 58.0276H6.91028Z",
    fill: "url(#paint55_linear_141_83)",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M115 58.0274C113.573 58.0274 112.384 56.8383 112.384 55.4114C112.384 53.9845 113.573 52.7954 115 52.7954C116.427 52.7954 117.616 53.9845 117.616 55.4114C117.616 56.8383 116.427 58.0274 115 58.0274Z",
    fill: "url(#paint56_radial_141_83)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M111.553 55.4113C111.553 54.6978 112.148 54.1033 112.861 54.1033H114.645C115.358 54.1033 115.953 54.6978 115.953 55.4113C115.953 56.1247 115.358 56.7193 114.645 56.7193H112.861C112.148 56.7193 111.553 56.1247 111.553 55.4113Z",
    fill: "url(#paint57_linear_141_83)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M112.74 56.6001C112.027 56.6001 111.432 56.0056 111.432 55.2921C111.432 54.5787 112.027 53.9841 112.74 53.9841C113.454 53.9841 114.048 54.5787 114.048 55.2921C114.048 56.0056 113.454 56.6001 112.74 56.6001Z",
    fill: "url(#paint58_linear_141_83)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3324 55.4107C96.3324 55.4107 96.4513 55.1729 96.5703 55.1729H112.385C112.385 55.1729 112.623 55.2918 112.623 55.4107C112.623 55.4107 112.504 55.6485 112.385 55.6485H96.5703C96.5703 55.6485 96.3324 55.5296 96.3324 55.4107Z",
    fill: "url(#paint59_linear_141_83)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.3419 99.6455C29.8604 100.002 55.6638 102.143 61.3715 102.143L141.517 102.143L144.014 98.8131L24.5095 28.8943H3.93814C0.37085 39.5962 0.133026 56.0057 0.133026 56.0057C0.133026 56.0057 -0.461517 78.1229 6.31633 88.3491C11.9051 96.6728 17.8506 99.051 25.3419 99.6455Z",
    fill: "url(#paint60_linear_141_83)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M206.678 56.006C206.678 57.7791 206.944 59.2165 207.272 59.2165C207.601 59.2165 207.867 57.7791 207.867 56.006C207.867 54.2328 207.601 52.7954 207.272 52.7954C206.944 52.7954 206.678 54.2328 206.678 56.006Z",
    fill: "url(#paint61_linear_141_83)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M207.629 53.9841L206.677 55.8867V56.4812L207.629 58.146L207.748 57.1947L207.034 56.1245L207.748 54.8165L207.629 53.9841Z",
    fill: "url(#paint62_linear_141_83)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2982 14.5067C21.2982 14.5067 17.7309 17.0038 12.6178 21.998C5.24542 29.3704 2.5105 33.77 2.5105 33.77C2.5105 33.77 3.6996 24.4951 10.5964 18.0739C15.7095 13.3176 21.1793 14.3877 21.1793 14.3877L21.2982 14.5067Z",
    fill: "url(#paint63_linear_141_83)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7031 14.5067C20.7031 14.5067 17.1358 17.0038 12.0227 21.998C4.65032 29.3704 2.74778 33.0566 2.74778 33.0566C2.74778 33.0566 3.22341 24.4951 10.1202 18.0739C15.2333 13.3176 20.7031 14.3877 20.7031 14.3877V14.5067Z",
    fill: "url(#paint64_linear_141_83)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0602 97.5055C21.0602 97.5055 17.374 94.6517 12.3798 90.0142C5.1263 83.2364 2.27246 78.2422 2.27246 78.2422C2.27246 78.2422 3.69938 87.1604 10.3583 93.9383C15.2336 98.9325 20.9413 97.6245 20.9413 97.6245L21.0602 97.5055Z",
    fill: "url(#paint65_linear_141_83)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3459 97.6243C20.3459 97.6243 16.5408 94.8894 11.5466 90.2519C4.29315 83.4741 2.5095 79.55 2.5095 79.55C2.5095 79.55 2.86624 87.3981 9.52517 94.1759C14.4005 99.1701 20.227 97.7432 20.227 97.7432L20.3459 97.6243Z",
    fill: "url(#paint66_linear_141_83)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.7031 14.5067C20.7031 14.5067 17.1358 17.0038 12.0227 21.998C4.65032 29.3704 2.74778 33.0566 2.74778 33.0566C2.74778 33.0566 3.22341 24.4951 10.1202 18.0739C15.2333 13.3176 20.7031 14.3877 20.7031 14.3877V14.5067Z",
    fill: "url(#paint67_linear_141_83)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3459 97.6243C20.3459 97.6243 16.5408 94.8894 11.5466 90.2519C4.29315 83.4741 2.5095 79.55 2.5095 79.55C2.5095 79.55 2.86624 87.3981 9.52517 94.1759C14.4005 99.1701 20.227 97.7432 20.227 97.7432L20.3459 97.6243Z",
    fill: "url(#paint68_linear_141_83)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M145.677 13.5559C139.969 15.2207 125.938 19.0258 119.992 19.7392C113.096 20.4527 90.2649 20.2149 86.3409 20.2149L89.9082 13.5559L145.677 13.5559ZM148.174 13.1992L89.6704 13.1992L85.7464 20.4527C85.7464 20.4527 112.501 20.8094 120.111 19.9771C127.721 19.1447 148.293 13.1992 148.293 13.1992H148.174Z",
    fill: "url(#paint69_linear_141_83)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0599 13.4366L80.5141 19.9766L43.2953 19.382L65.1747 13.4366L82.0599 13.4366ZM82.5355 13.0798L65.0558 13.0798L40.6793 19.7388L80.633 20.3333L82.4166 13.0798H82.5355Z",
    fill: "url(#paint70_linear_141_83)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M145.677 98.4574H89.9081L86.3408 91.9173C90.2648 91.9173 113.214 91.6795 119.992 92.393C125.938 92.9875 139.969 96.9115 145.677 98.5763V98.4574ZM148.174 98.8141C148.174 98.8141 127.602 92.7497 119.992 92.0362C112.382 91.2039 85.6274 91.5606 85.6274 91.5606L89.5514 98.933H148.055L148.174 98.8141Z",
    fill: "url(#paint71_linear_141_83)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M82.06 98.5759H65.1748L43.2955 92.5116L80.5142 91.917L82.06 98.457V98.5759ZM82.5356 99.0516L80.752 91.7981L40.7984 92.3926L65.1748 98.9327H82.6545L82.5356 99.0516Z",
    fill: "url(#paint72_linear_141_83)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 21.166C5.24487 26.2791 2.74778 33.1759 2.74778 33.1759C2.74778 33.1759 4.65032 29.4897 12.0227 22.1173C17.1358 17.0042 20.7031 14.626 20.7031 14.626C20.7031 14.626 14.8765 16.1718 10.0013 21.2849V21.166Z",
    fill: "url(#paint73_linear_141_83)",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16844 90.9654C4.41205 85.8523 2.62842 79.55 2.62842 79.55C2.62842 79.55 4.29316 82.7606 11.6656 90.133C16.7787 95.2461 20.3459 97.6243 20.3459 97.6243C20.3459 97.6243 13.9248 96.0785 9.16844 90.9654Z",
    fill: "url(#paint74_linear_141_83)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M113.215 10.9394C113.215 10.9394 113.215 10.5826 113.097 10.5826C112.502 9.86917 110.48 9.63135 107.151 9.63135C103.822 9.63135 100.135 10.3448 99.8975 11.0583V11.2961L104.059 11.2961L104.297 10.9394C104.297 10.9394 105.843 10.4637 107.508 10.4637C109.173 10.4637 110.718 10.8204 110.718 10.8204V11.0583H113.453L113.215 10.9394Z",
    fill: "url(#paint75_linear_141_83)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M110.48 10.8209C110.48 10.8209 109.053 10.2263 107.151 10.2263C105.248 10.2263 104.059 10.8209 104.059 10.8209C104.059 10.8209 105.129 10.4641 107.151 10.4641C109.172 10.4641 110.48 10.702 110.48 10.702V10.8209Z",
    fill: "#252125"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M113.215 100.716C113.215 100.716 113.215 101.073 113.097 101.073C112.502 101.786 110.48 102.024 107.151 102.024C103.822 102.024 100.135 101.31 99.8975 100.597V100.359H104.059L104.297 100.716C104.297 100.716 105.843 101.192 107.508 101.192C109.173 101.192 110.718 100.835 110.718 100.835V100.597H113.453L113.215 100.716Z",
    fill: "url(#paint76_linear_141_83)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M110.48 100.835C110.48 100.835 109.053 101.43 107.151 101.43C105.248 101.43 104.059 100.835 104.059 100.835C104.059 100.835 105.129 101.192 107.151 101.192C109.172 101.192 110.48 100.954 110.48 100.954V100.835Z",
    fill: "#252125"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7328 10.9394C78.7328 10.9394 78.7328 10.5826 78.6139 10.5826C78.0193 9.86917 75.9978 9.63135 72.6684 9.63135C69.3389 9.63135 65.6527 10.3448 65.4149 11.0583V11.2961L69.5767 11.2961L69.8145 10.9394C69.8145 10.9394 71.3604 10.4637 73.0251 10.4637C74.6898 10.4637 76.2357 10.8204 76.2357 10.8204V11.0583H78.9706L78.7328 10.9394Z",
    fill: "url(#paint77_linear_141_83)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1169 10.8209C76.1169 10.8209 74.69 10.2263 72.7875 10.2263C70.8849 10.2263 69.6958 10.8209 69.6958 10.8209C69.6958 10.8209 70.766 10.4641 72.7875 10.4641C74.8089 10.4641 76.1169 10.702 76.1169 10.702V10.8209Z",
    fill: "#252125"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M79.563 100.716C79.563 100.716 79.563 101.073 79.4441 101.073C78.8495 101.786 76.828 102.024 73.4986 102.024C70.1691 102.024 66.4829 101.31 66.2451 100.597V100.359H70.4069V100.716C70.4069 100.716 72.1906 101.192 73.7364 101.192C75.2822 101.192 76.947 100.835 76.947 100.835V100.597H79.6819L79.563 100.716Z",
    fill: "url(#paint78_linear_141_83)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9474 100.835C76.9474 100.835 75.5205 101.43 73.6179 101.43C71.7154 101.43 70.5263 100.835 70.5263 100.835C70.5263 100.835 71.5965 101.192 73.6179 101.192C75.6394 101.192 76.9474 100.954 76.9474 100.954V100.835Z",
    fill: "#252125"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M164.075 45.3096L163.726 35.4463L163.25 35.4631L163.6 45.3264L164.075 45.3096Z",
    fill: "url(#paint79_linear_141_83)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M160.421 31.1541C160.421 31.1541 160.421 30.9163 160.659 30.7974C160.897 30.7974 161.016 30.7974 161.135 31.0352C161.135 31.0352 163.275 38.5265 163.989 44.8287C164.702 52.0822 164.583 58.5033 164.583 58.6222C164.583 58.86 164.464 58.9789 164.227 58.9789C163.989 58.9789 163.87 58.86 163.87 58.6222C163.87 58.6222 163.87 52.2011 163.275 44.9476C162.681 38.6454 160.54 31.273 160.54 31.273L160.421 31.1541Z",
    fill: "url(#paint80_linear_141_83)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M163.395 46.2564L163.157 43.6404L163.871 43.5215L164.109 46.1375L163.395 46.2564Z",
    fill: "url(#paint81_linear_141_83)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M162.444 27.9436L163.276 35.9105H163.752L163.633 32.3433L162.444 27.9436Z",
    fill: "#231E22"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M164.656 69.44L164.208 69.2805L160.978 78.3547L161.426 78.5142L164.656 69.44Z",
    fill: "url(#paint82_linear_141_83)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M156.499 90.6085C156.499 90.6085 156.499 90.6085 156.499 90.4896C156.499 90.4896 158.877 84.7819 160.779 77.8852C162.444 71.8208 163.276 63.4971 163.276 63.4971C163.276 63.2593 163.514 63.1404 163.633 63.1404C163.871 63.1404 163.99 63.3782 163.99 63.4971C163.99 63.4971 163.158 71.9397 161.493 78.0041C159.59 84.9008 157.212 90.7274 157.093 90.7274C157.093 90.9652 156.855 90.9652 156.617 90.9652C156.499 90.9652 156.38 90.7274 156.38 90.6085H156.499Z",
    fill: "url(#paint83_linear_141_83)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M160.42 79.0743L161.253 76.5771L161.847 76.815L161.134 79.3121L160.42 79.0743Z",
    fill: "url(#paint84_linear_141_83)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M166.01 61.7136L164.108 69.6806L164.464 69.7995L165.654 66.5889L166.01 61.7136Z",
    fill: "#231E22"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M154.952 14.8638C156.26 16.1718 157.331 17.5987 158.282 19.1445C158.757 19.858 159.233 20.6904 159.709 21.5227C160.065 22.3551 160.541 23.1875 160.898 24.0198C162.444 27.3493 163.514 30.7977 164.346 34.365C166.011 41.4995 166.605 48.753 166.605 56.0065C166.605 63.26 165.773 70.5135 164.108 77.6481C162.325 84.6637 159.709 91.6794 155.071 97.2682C157.449 94.4143 159.114 91.2038 160.422 87.8743C161.849 84.5448 162.919 81.0964 163.752 77.5291C165.416 70.5135 166.13 63.26 166.13 56.0065C166.13 48.753 165.654 41.4995 163.989 34.365C163.157 30.7977 162.087 27.3493 160.66 24.0198C160.303 23.1875 159.947 22.3551 159.471 21.5227C158.995 20.6904 158.639 19.858 158.163 19.1445C157.212 17.5987 156.26 16.0529 154.952 14.7449V14.8638Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_141_83",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_141_83",
    transform: "scale(0.333333 0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_141_83",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_141_83",
    transform: "scale(0.125 0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_141_83",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_141_83",
    transform: "scale(0.142857 0.333333)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_141_83",
    x1: 147.343,
    y1: 103.808,
    x2: 147.343,
    y2: 83.1179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D9DCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E0E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E2E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D9DAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D2D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D0D0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C9CAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B4B7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ADB1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_141_83",
    x1: 129.151,
    y1: 93.5817,
    x2: 150.317,
    y2: 93.5817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.891 13.8417) rotate(91.42) scale(2.55656 14.7258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_141_83",
    x1: 148.057,
    y1: 95.9595,
    x2: 148.057,
    y2: 101.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_141_83",
    x1: 208.463,
    y1: 8.2041,
    x2: 208.463,
    y2: 28.8944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D9DCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E0E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E2E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D9DAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D2D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D0D0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C9CAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B4B7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ADB1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_141_83",
    x1: 129.151,
    y1: 18.5492,
    x2: 150.317,
    y2: 18.5492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.554 -118.246) rotate(88.7) scale(2.55656 14.7258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_141_83",
    x1: 37.5896,
    y1: 12871.3,
    x2: 37.5896,
    y2: 12859.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D9DCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E0E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E2E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D9DAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D2D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D0D0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C9CAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B4B7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ADB1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_141_83",
    x1: 19.2781,
    y1: 12859.1,
    x2: 40.5629,
    y2: 12847.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9135 14.4162) rotate(91.42) scale(2.55656 14.7258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_141_83",
    x1: 38.3029,
    y1: -0.000700519,
    x2: 38.3029,
    y2: 11.8903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_141_83",
    x1: 37.5898,
    y1: 8.2041,
    x2: 37.5898,
    y2: 28.8944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D9DCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E0E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E2E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D9DAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D2D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D0D0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C9CAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B4B7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ADB1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_141_83",
    x1: 19.2784,
    y1: 18.5492,
    x2: 40.5632,
    y2: 18.5492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.5864 -118.783) rotate(88.7) scale(2.55656 14.7258)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_141_83",
    x1: 104.297,
    y1: 9.98829,
    x2: 104.297,
    y2: 102.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#CED0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D9DCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#E0E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E2E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#D9DAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D2D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D0D0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C9CAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B4B7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ADB1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_141_83",
    x1: 200.853,
    y1: 25.208,
    x2: 195.026,
    y2: 25.0891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#535350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#5C5C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#757572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8C8C89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_141_83",
    x1: 184.92,
    y1: 14.8628,
    x2: 202.876,
    y2: 32.6992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#797976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9B9B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B6B6B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C9C9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D5D5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D9D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_141_83",
    x1: 200.022,
    y1: 24.8516,
    x2: 200.022,
    y2: 32.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E7E8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#DEDFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DCDCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D7D7D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C9C9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B2B2B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#929291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_141_83",
    x1: 208.463,
    y1: 86.8041,
    x2: 208.463,
    y2: 86.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#535350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#5C5C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#757572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8C8C89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_141_83",
    x1: 184.92,
    y1: 97.1488,
    x2: 202.876,
    y2: 79.3124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#797976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9B9B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B6B6B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C9C9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D5D5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D9D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_141_83",
    x1: 208.464,
    y1: 87.1605,
    x2: 208.464,
    y2: 79.7881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E7E8E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#DEDFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DCDCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D7D7D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C9C9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B2B2B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#929291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(210.117 46.9549) rotate(150.01) scale(1.19861 8.50441)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_141_83",
    x1: 0.132432,
    y1: 56.0066,
    x2: 33.665,
    y2: 56.0066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_141_83",
    x1: 78.495,
    y1: 21.2839,
    x2: 78.495,
    y2: 90.8461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#D9DCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E0E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E2E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D9DAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#D3D3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D2D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D0D0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#C9CAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B4B7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ADB1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_141_83",
    x1: 75.8784,
    y1: 18.9061,
    x2: 75.8784,
    y2: 59.9299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E3E3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#DCDCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D7D7D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C9CAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B2B5B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#929791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#808780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_141_83",
    x1: 137.949,
    y1: 7.84803,
    x2: 136.522,
    y2: 10.2262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_141_83",
    x1: 139.139,
    y1: 3.32947,
    x2: 136.761,
    y2: 6.89676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#C8C8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D8D9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E4E6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EBEDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EAECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#E1E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D3D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#BEC2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_141_83",
    x1: 134.383,
    y1: 0.000115499,
    x2: 134.383,
    y2: 9.98852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#636360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7B7B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A4A4A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D9D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_141_83",
    x1: 137.95,
    y1: 104.403,
    x2: 136.523,
    y2: 102.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_141_83",
    x1: 139.139,
    y1: 108.921,
    x2: 136.761,
    y2: 105.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#C8C8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D8D9D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E4E6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EBEDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EAECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#E1E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D3D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#BEC2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADB1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_141_83",
    x1: 208.464,
    y1: 112.131,
    x2: 208.464,
    y2: 102.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#636360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7B7B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A4A4A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D9D9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_141_83",
    x1: 117.02,
    y1: 13.1987,
    x2: 117.02,
    y2: 20.5711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_141_83",
    x1: 61.6074,
    y1: 13.0798,
    x2: 61.6074,
    y2: 20.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_141_83",
    x1: 181.707,
    y1: 14.8638,
    x2: 181.707,
    y2: 97.2681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E9EBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F0F2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFF1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#E6E7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DCDCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD2CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_141_83",
    x1: 117.02,
    y1: 91.4417,
    x2: 117.02,
    y2: 98.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_141_83",
    x1: 61.6074,
    y1: 91.679,
    x2: 61.6074,
    y2: 99.0514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#404040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_141_83",
    x1: 20.1093,
    y1: 21.1654,
    x2: 20.1093,
    y2: 90.8465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_141_83",
    x1: 144.725,
    y1: 15.4575,
    x2: 144.725,
    y2: 96.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.735 -273.378) rotate(90) scale(0.463747 46.1429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_141_83",
    x1: 180.28,
    y1: 68.8487,
    x2: 184.204,
    y2: 95.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.544 191.6) rotate(92.08) scale(2.14751 21.2705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_141_83",
    x1: 144.725,
    y1: 15.4575,
    x2: 144.725,
    y2: 57.6704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#EFF1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#E6E7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DCDCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D7D7D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C9C9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B2B2B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#929291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.05 21.5934) rotate(75.17) scale(0.970302 17.4654)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.376 12.1856) rotate(90) scale(0.970303 44.5126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.376 101.358) rotate(90) scale(0.970307 44.5126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.376 100.169) rotate(90) scale(0.970302 44.5126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.051 88.5547) rotate(106.03) scale(0.970302 17.4654)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-7.94504 1045.67) rotate(100.82) scale(6.2594 33.8274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-177.242 89.2455) rotate(178.42) scale(15.0682 67.2743)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.4733 -299.001) rotate(80.66) scale(30.9736 29.0377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_141_83",
    x1: 155.19,
    y1: 14.6262,
    x2: 205.37,
    y2: 34.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#B4B7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C1C4C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#E5E6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C6C9C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#B4B7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#C1C3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#E5E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_141_83",
    x1: 155.19,
    y1: 97.3871,
    x2: 205.37,
    y2: 77.1724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#BDBFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#C9CAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D0D0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D2D2D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DBDBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(215.367 -112.229) rotate(108.62) scale(4.34615 19.4061)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3398 129.15) rotate(84.59) scale(3.94185 19.4061)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2142 219.82) rotate(94.83) scale(3.94185 19.4061)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_141_83",
    x1: 20.1093,
    y1: 21.1656,
    x2: 20.1093,
    y2: 58.0276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#929291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B2B2B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C9C9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D7D7D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#DCDCDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#E6E7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EFF1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F4F3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_141_83",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115 55.4114) rotate(90) scale(2.61601)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_141_83",
    x1: 113.694,
    y1: 54.1033,
    x2: 113.694,
    y2: 56.6004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_141_83",
    x1: 112.74,
    y1: 54.103,
    x2: 112.74,
    y2: 56.6001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242424"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_141_83",
    x1: 104.537,
    y1: 55.0539,
    x2: 104.537,
    y2: 55.6485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_141_83",
    x1: 41.6325,
    y1: 113.796,
    x2: 76.1163,
    y2: 60.5242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_141_83",
    x1: 207.272,
    y1: 52.7954,
    x2: 207.272,
    y2: 59.2165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_141_83",
    x1: 207.153,
    y1: 53.9841,
    x2: 207.153,
    y2: 58.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82827D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6C6C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#5D5D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#53534B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#515148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#54544C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7E8079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9DA09B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B0B3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B7BBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B0B3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9C9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A2A2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B6B6B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D5D5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E5E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DFDFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#CECECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B4B4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9C9C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_141_83",
    x1: 11.9044,
    y1: 14.3877,
    x2: 11.9044,
    y2: 33.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B4B4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CECECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#DFDFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E5E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D5D5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#B6B6B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A2A2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#9C9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#B0B3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B7BBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B0B3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9DA09B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7E8079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#54544C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#515148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#53534B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#5D5D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#6C6C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#82827D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_141_83",
    x1: 11.666,
    y1: 14.3877,
    x2: 11.666,
    y2: 33.1755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#8A0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#830000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_141_83",
    x1: 11.6663,
    y1: 78.2422,
    x2: 11.6663,
    y2: 97.6245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B4B4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CECECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#DFDFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E5E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#D5D5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#B6B6B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A2A2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#9C9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#B0B3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B7BBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#B0B3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9DA09B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7E8079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#54544C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#515148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#53534B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#5D5D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#6C6C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#82827D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_141_83",
    x1: 11.4277,
    y1: 79.55,
    x2: 11.4277,
    y2: 97.8621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E00000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C10000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#8A0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#830000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_141_83",
    x1: 8.21762,
    y1: 20.571,
    x2: 10.8336,
    y2: 23.0681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_141_83",
    x1: 7.50371,
    y1: 91.7977,
    x2: 10.7143,
    y2: 89.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_141_83",
    x1: 117.02,
    y1: 13.1992,
    x2: 117.02,
    y2: 20.5716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8A8A83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#8C8C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#949490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9C9C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_141_83",
    x1: 61.6074,
    y1: 13.0798,
    x2: 61.6074,
    y2: 20.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8A8A83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#8C8C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#949490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9C9C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_141_83",
    x1: 117.02,
    y1: 91.4417,
    x2: 117.02,
    y2: 98.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#949490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8C8C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8A8A83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_141_83",
    x1: 61.6075,
    y1: 91.6792,
    x2: 61.6075,
    y2: 99.0516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#949490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8C8C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8A8A83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_141_83",
    x1: 9.64454,
    y1: 21.8795,
    x2: 11.1904,
    y2: 23.4253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_141_83",
    x1: 9.16845,
    y1: 90.7276,
    x2: 10.9521,
    y2: 89.0628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CACBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#929393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_141_83",
    x1: 106.438,
    y1: 9.63135,
    x2: 106.438,
    y2: 11.1772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EAECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E1E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D3D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#BEC2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ADB1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#AFB3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B8BDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_141_83",
    x1: 208.462,
    y1: 101.905,
    x2: 208.462,
    y2: 100.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EAECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E1E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D3D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#BEC2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ADB1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#AFB3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B8BDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_141_83",
    x1: 72.0738,
    y1: -0.00033041,
    x2: 72.0738,
    y2: 11.8906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EAECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E1E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D3D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#BEC2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ADB1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#AFB3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B8BDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_141_83",
    x1: 72.904,
    y1: 101.905,
    x2: 72.904,
    y2: 100.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEF0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EDEFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EAECEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E1E4E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D3D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#BEC2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ADB1AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#AFB3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B8BDB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_141_83",
    x1: 163.302,
    y1: 34.9298,
    x2: 164.033,
    y2: 44.7913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#454545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_141_83",
    x1: 161.504,
    y1: 30.6339,
    x2: 164.44,
    y2: 58.8487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#454545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_141_83",
    x1: 163.94,
    y1: 44.8423,
    x2: 163.231,
    y2: 44.9162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82827D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6C6C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#5D5D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#53534B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#515148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#54544C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7E8079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9DA09B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B0B3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B7BBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B0B3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9C9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A2A2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B6B6B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D5D5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E5E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DFDFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#CECECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B4B4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9C9C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_141_83",
    x1: 166.592,
    y1: 64.9364,
    x2: 163.056,
    y2: 73.9572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#454545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_141_83",
    x1: 166.748,
    y1: 59.571,
    x2: 157.119,
    y2: 86.4658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#454545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_141_83",
    x1: 163.073,
    y1: 74.0636,
    x2: 162.401,
    y2: 73.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82827D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#6C6C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#5D5D55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#53534B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#515148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#54544C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7E8079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9DA09B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#B0B3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#B7BBB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B0B3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9C9C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A2A2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#B6B6B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#D5D5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E5E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#DFDFDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#CECECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B4B4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9C9C9A"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_141_83",
    width: 3,
    height: 6,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAACXBIWXMAAAsSAAALEgHS3X78AAAAF0lEQVQImWP4////fwYoYGJAAkRyUAAALpsEBesA4xEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_141_83",
    width: 8,
    height: 4,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAACXBIWXMAAAsSAAALEgHS3X78AAAARElEQVQImW2MsQ0AMQgDHZIB2YQZ2IApGNP+An0RKe58tg6ZKTzyczvHXjv2Hm7kCCJCkuTul9Gk6VUFkuhuAMBac/gAku8Z6jrpu1oAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_141_83",
    width: 7,
    height: 3,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAADCAYAAABfwxXFAAAACXBIWXMAAAsSAAALEgHS3X78AAAANElEQVQImV2KQQ4AEBDESjybg2V/LcYBkeitaXFv6r2Jg1mV+/bIhwRjTACiBDmXcGNK718GqhKdOFciiwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.a7fd04f090194e8861d557b6975151d3.svg";
export { ForwardRef as ReactComponent };